const ROLES = {
  User: 2001,
  Editor: 1984,
  Admin: 5150,
  PowerAdmin: 6879,
};

export default ROLES;
